// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.muorjxWWscWQe_zh {
	padding: var(--lok-spacing-7);
}

.oySPvtgK8mpAJ98F {
	flex: 1;
}

.YMOymkIr_pg1bVqT {
	font: var(--lok-typography-heading-3);
	font-family: var(--lok-font-family-inter);
}

.RWtTrbmoXV0SolCA {
	font: var(--lok-typography-body-small-default);
	font-family: var(--lok-font-family-inter);
}

.qK71MItDdFMWovWU {
	height: 100%;
}

.SE6MnAVDXQUa6l9a {
	width: 470px;
	min-height: 538px;
}
`, "",{"version":3,"sources":["webpack://./packages/rag/src/components/AssignmentModal/components/ActivationStep/ActivationStep.module.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,OAAO;AACR;;AAEA;CACC,qCAAqC;CACrC,yCAAyC;AAC1C;;AAEA;CACC,8CAA8C;CAC9C,yCAAyC;AAC1C;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,YAAY;CACZ,iBAAiB;AAClB","sourcesContent":[".container {\n\tpadding: var(--lok-spacing-7);\n}\n\n.contents {\n\tflex: 1;\n}\n\n.heading {\n\tfont: var(--lok-typography-heading-3);\n\tfont-family: var(--lok-font-family-inter);\n}\n\n.subheading {\n\tfont: var(--lok-typography-body-small-default);\n\tfont-family: var(--lok-font-family-inter);\n}\n\n.footer {\n\theight: 100%;\n}\n\n.imageContainer {\n\twidth: 470px;\n\tmin-height: 538px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `muorjxWWscWQe_zh`,
	"contents": `oySPvtgK8mpAJ98F`,
	"heading": `YMOymkIr_pg1bVqT`,
	"subheading": `RWtTrbmoXV0SolCA`,
	"footer": `qK71MItDdFMWovWU`,
	"imageContainer": `SE6MnAVDXQUa6l9a`
};
export default ___CSS_LOADER_EXPORT___;
